<template>
  <div class="parent">
        <v-card class="child one">
          <v-img
              contain
              max-width="400"
              :src="require('@/assets/images/temp_analytics.png')"
          ></v-img>
        </v-card>
        <v-card class="child two">
          <v-img
            contain
            max-width="400"
            :src="require('@/assets/images/temp_calendar.png')"
          ></v-img>
        </v-card>
      </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.parent{
  position: relative;
  height: 410px;
}

.child{
  position: absolute;
  width: fit-content;
  height: fit-content;

}

.one{
  top: 60px;
  left:30px;
}

.two{
  top: 150px;
  left: 100px;
}

</style>
